import { Fragment, useMemo, useState } from "react";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import Select from "react-select";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { API_BASE_URL } from "../../api/api";
import { getInfluencerBonusColumns } from "../../Components/influencerBonus/InfluencerBonusColumns";
import { InfluencerBonusModal } from "../../Components/influencerBonus/InfluencerBonusModal";

export const InfluencerBonusList = () => {
  const { getData } = useDataFetch();

  const [filters, setFilters] = useState({ settlementId: "" });
  const [appliedFilters, setAppliedFilters] = useState({ settlementId: "" });
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedBonus, setSelectedBonus] = useState(null);

  const closeModal = () => {
    setModalOpen(false);
    setSelectedBonus(null);
  };

  const { data: settlementsSummary } = getData(
    ["settlements-summary"],
    "/settlements/summary"
  );

  const settlementOptions = useMemo(
    () =>
      settlementsSummary?.data
        ?.filter((s) => s.type === "INFLUENCER_BONUS")
        .map((s) => {
          // Extraer solo la parte de fecha sin conversión de zona horaria
          const start = s.period.start.split('T')[0].split('-').reverse().join('/');
          const end = s.period.end.split('T')[0].split('-').reverse().join('/');
          return {
            value: s.id,
            label: `${start} - ${end}`,
          };
        }) || [],
    [settlementsSummary]
  );

  const { data, isLoading } = getData(
    ["influencer-bonuses", appliedFilters, pagination],
    "/settlements/influencer-bonuses",
    {},
    {
      page: pagination.pageIndex + 1,
      limit: pagination.pageSize,
      ...(appliedFilters.settlementId
        ? { id: appliedFilters.settlementId }
        : {}),
    }
  );

  const columns = useMemo(
    () => getInfluencerBonusColumns(setSelectedBonus, setModalOpen),
    []
  );

  const handleSearch = () => {
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    setAppliedFilters({
      settlementId: filters.settlementId || "",
    });
  };

  const handleGenerateExcel = () => {
    const params = new URLSearchParams();
    params.set("page", pagination.pageIndex + 1);
    params.set("limit", pagination.pageSize);
    if (appliedFilters.settlementId)
      params.set("id", appliedFilters.settlementId);

    window.open(
      `${API_BASE_URL}/settlements/report/excel/influencer-bonus?${params.toString()}`,
      "_blank"
    );
  };

  return (
    <Fragment>
      <Breadcrumbs
        parent="Liquidaciones"
        title="Bonos de Influencers"
        mainTitle="Bonos de Influencers"
      />
      <Container fluid>
        <Row className="gx-3 gy-2 align-items-end mb-3">
          <Col xs="12" sm="6" md="4">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1">Periodo</Label>
              <Select
                classNamePrefix="react-select"
                isClearable
                placeholder="Selecciona"
                options={settlementOptions}
                value={
                  settlementOptions.find(
                    (opt) => opt.value === filters.settlementId
                  ) || null
                }
                onChange={(option) =>
                  setFilters((prev) => ({
                    ...prev,
                    settlementId: option ? option.value : "",
                  }))
                }
              />
            </FormGroup>
          </Col>
          <Col xs="12" sm="6" md="4">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1 d-block">&nbsp;</Label>
              <Button color="primary" size="sm" onClick={handleSearch}>
                <i className="fa fa-search me-1" /> Buscar
              </Button>
            </FormGroup>
          </Col>
          <Col xs="12" sm="6" md="4" className="text-end">
            <Btn attrBtn={{ color: "success", onClick: handleGenerateExcel }}>
              <i className="fa fa-file-excel-o"></i> Exportar Excel
            </Btn>
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <DataTable
                  data={data?.data ?? []}
                  total={data?.pagination?.total ?? 0}
                  pagination={pagination}
                  setPagination={setPagination}
                  columns={columns}
                  progressPending={isLoading}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <InfluencerBonusModal
        isOpen={modalOpen}
        toggle={closeModal}
        bonus={selectedBonus}
      />
    </Fragment>
  );
};
